const INITIAL_STATE = {
    basecontentlist: [], // sebagai root untuk filter
    contentlist: [],
    category1list: [],
    category2list: []
}

const ContentListReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case 'ADD_CONTENTLIST':
            return state = {
                basecontentlist: action.contentlist,
                contentlist: action.contentlist,
                category1list:  [...new Map(action.contentlist.map(o => [o.CatID_1, o])).values()],
                category2list:  [...new Map(action.contentlist.map(o => [o.CatID_2, o])).values()]
            }
        case 'SORT_RELEVANT':
            return {
                ...state,
                contentlist: state.contentlist.sort((a,b) => (parseInt(a.Relevant_Point) > parseInt(b.Relevant_Point)) ? -1 : (parseInt(a.Relevant_Point) === parseInt(b.Relevant_Point)) ? -1 : 1),
            }
        case 'SORT_POPULAR':
            return {
                ...state,
                contentlist: state.contentlist.sort((a,b) => (parseInt(a.View) > parseInt(b.View)) ? -1 : (parseInt(a.View) === parseInt(b.View)) ? -1 : 1),
            }
        case 'SORT_TERBARU':
            return {
                ...state,
                contentlist: state.contentlist.sort((a,b) => (a.OnAirDate > b.OnAirDate) ? -1 : (a.OnAirDate === b.OnAirDate) ? -1 : 1)
            }
        case 'SORT_TERBANTU':
            return {
                ...state,
                contentlist: state.contentlist.sort((a,b) => (parseInt(a.Helpful) > parseInt(b.Helpful)) ? -1 : (parseInt(a.Helpful) === parseInt(b.Helpful)) ? -1 : 1)
            }
        case 'CLEAR_FILTER_CAT':
            return {
                ...state,
                contentlist: state.basecontentlist
            }
        case 'FILTER_CAT1':
            return {
                ...state,
                contentlist: state.basecontentlist.filter(content => content.CatID_1 === action.category1),
            }
        case 'FILTER_CAT2':
            return {
                ...state,
                contentlist: state.contentlist.filter(content => content.CatID_2 === action.category2),
            }
        default:
            return state
    }
}

export default ContentListReducer